<template>
  <Modal
    v-model="_value"
    width="500"
    title="保险渠道详细"
    @on-visible-change="visibleChange"
    >
    <Form ref="loginForm" :model="insurancechannel" :rules="rules" >
      <FormItem prop="name">
        <Input v-model="insurancechannel.name":disabled="!modify"  placeholder="请输入保险渠道名称">
        </Input>
      </FormItem>
      <FormItem prop="telephoneNum">
        <Input v-model="insurancechannel.telephoneNum":disabled="!modify"  placeholder="请输入联系电话">
        </Input>
      </FormItem>
      <FormItem prop="address">
        <Input v-model="insurancechannel.address":disabled="!modify"  placeholder="请输入联系地址">
        </Input>
      </FormItem>
    </Form>
    <Row style="text-align: right;">
      <i-switch v-model="modify" @on-change="modifyChange" size="large">
        <span slot="open">保存</span>
        <span slot="close">修改</span>
      </i-switch>
    </Row>
  </Modal>
</template>
<script>

  import Vue from 'vue';
  import {mapActions} from 'vuex'
  import store from '@/store'
  import {genQueryParam, genSortParam} from "@/libs/queryparamhelper"

  export default {
    name: 'InsurancechannelInfoModal',
    props: {
      value: {
        type: Boolean,
        default: false
      },
      initValue: null,
      nameRules: {
        type: Array,
        default: () => {
          return [
            { required: true, message: '保险渠道名称不能为空', trigger: 'blur' }
          ]
        }
      },
    },
    data() {
      return {
        modify: false,

        insurancechannel: {
          name:null,
          telephoneNum:null,
          address:null,
          lat:null,
          lng:null,
        }
      }
    },
    methods: {
      ...mapActions([
        'InsuranceChannelServ_GetDetail',
        'InsuranceChannelServ_ModifyObj',
      ]),
      modifyChange(status) {
        if (status === false) {
          this.$Modal.confirm({
            title: '确认保险渠道信息',
            content: '<p>确认保险渠道信息</p>',
            onOk: () => {
              store.dispatch('InsuranceChannelServ_ModifyObj', {
                params: this.insurancechannel
              }).then(() => {
                this.$Message.success('修改成功')
                this.$emit('on-success')
              }).catch(err => {
                this.$Message.error(err)
                this.$emit('on-fail')
              });
            },
            onCancel: () => {
              let insurancechannelId = this._initValue
              store.dispatch('InsuranceChannelServ_GetDetail', {
                params: {id: insurancechannelId}
              }).then(() => {
                this.insurancechannel = store.getters.get_InsuranceChannel_GetDetailResult;
              }).catch(err => {
                this.$Message.error(err)
              })
            }
          });
        }
      },
      visibleChange(val) {
        if(val){
          this.insurancechannel.name = null
          this.insurancechannel.telephoneNum = null
          this.insurancechannel.address = null
          this.insurancechannel.lat = null
          this.insurancechannel.lng = null
        }
        store.dispatch('InsuranceChannelServ_GetDetail', {
          params:{
          id: this._initValue
          }
        }).then(() => {
          this.insurancechannel = store.getters.get_InsuranceChannel_GetDetailResult
        }).catch(err => {
          this.$Message.error(err)
          this.$emit('on-fail');
        })
      }
    },
    computed: {
      _value: {
        get() {
          return this.value;
        },
        set(val) {
          this.$emit('input', val)
          this.$emit('change', val)
        }
      },
      _initValue: {
        get() {
          return this.initValue
        },
        set(val) {
          // this.$emit('input', val);
          // this.$emit('change', val);
        }
      },
      rules () {
        return {
          name: this.nameRules,
        }
      }
    },
    mounted() {
      this.$nextTick(() => {

      })
    }
  }
</script>
